module.exports = __webpack_public_path__ + "static/media/ledger.17acc780.svg";